import { createTheme } from "@mui/material/styles";

const themeColor = {
    purple: {
        primary: {
            main: "#6629D7",
            secondary: "#F2EFFA",
            darker: "#4B1F9C",
            lighter: "#EAE5F7",
            hover: "#6E42F7",
            other: "#CEBEEB",
            disabled: "#9883D0",
        },
    },
    green: {
        primary: {
            main: "#73D343",
            darker: "#008905",
        },
    },

    yellow: {
        primary: {
            main: "#FFFF00",
            darker: "#FEFFE5",
        },
    },
    black: {
        primary: {
            main: "#18181b",
            darker: "#000000",
        },
    },

    pink: {
        primary: {
            main: "#FF516F",
            ligther: "#FBEEEE",
        },
    },
    grey: {
        primary: {
            main: "#ECECED",
            secondary: "#CFD4DA",
            darker: "#bcbcbc",
            lighter: "#F2F5F9",
            other: "#777E84",
        },
    },
    lightGrey: {
        primary: {
            main: "#FAFBFB",
            darker: "#EAECEF",
        },
    },

    white: {
        primary: {
            main: "#FFFFFF",
        },
    },
    orange: {
        primary: {
            main: "#FF874F",
            darker: "#F06437",
            hover: "#F06437",
            lighter: "#FAECE6",
        },
    },
};

const GlobalTheme = createTheme({
    palette: {
        purple: themeColor.purple,
        green: themeColor.green,
        yellow: themeColor.yellow,
        black: themeColor.black,
        pink: themeColor.pink,
        grey: themeColor.grey,
        lightGrey: themeColor.lightGrey,
        white: themeColor.white,
        orange: themeColor.orange,
    },
    typography: {
        fontFamily:
            '"Calibre", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
        fontFamilyMonospace:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        fontWeightRegular: 400,
        fontWeightLight: 600,
        fontWeightBold: 700,
        h1: {
            fontSize: "36px",
            lineHeight: 1.2,
            fontWeight: "normal",
        },
        h2: {
            fontSize: "28px",
            lineHeight: 1.2,
            fontWeight: "normal",
        },
        h3: {
            fontSize: "22px",
            lineHeight: 1.2,
            fontWeight: "normal",
        },
        p: {
            fontSize: "18px",
            lineHeight: 1.3,
            fontWeight: "normal",
        },
    },
});

export default GlobalTheme;
